import React from 'react';
import '../About/Aboutinfo.css';

const Aboutinfo = () => {
  return (
    <div className='section'>
        <div className="container grid-container">
            <div>
                <div className='about-info-content'>
                    <h2 className='heading-secondary'>A few words <span>about us</span></h2>
                    <h4>let us introduce ourselves</h4>
                    <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Doloremque, porro non nihil impedit blanditiis quam dignissimos expedita atque pariatur corporis tempore neque quidem odit aliquam exercitationem explicabo veritatis nisi quia!</p>
                </div>
                 </div>

                 <div>
                <div className='about-info-content'>
                    <h2 className='heading-secondary'>A place to wine, <span>place to dine</span></h2>
                    <h4>we hope to see you soon </h4>
                    <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Doloremque, porro non nihil impedit blanditiis quam dignissimos expedita atque pariatur corporis tempore neque quidem odit aliquam exercitationem explicabo veritatis nisi quia!</p>
                </div>
                </div>
        </div>

    </div>
  )
}

export default Aboutinfo